<template>
    <widget :router="tabName == 1 ? router1 : router2" :class="'widget_level'+widgetType" :key="reash">
        <template slot="title">
            <span :class="{is_active:tabName == 2}" @click="tabNameFn(2)">个人备课</span>
            <span :class="{is_active:tabName == 1}" @click="tabNameFn(1)">协同备课</span>
        </template>
        <div class="widget_cont">
            <template v-if="tabName == 1">
                <div v-for="(prepare,index) in tableData.synergeticPreparation" class="prepar_list" :key="index">
                    <div class="img_box" v-if="widgetType != 1"><img :src="imgUrl + prepare.prepareImgUrl" @error="errorImg($event,'image')"></div>
                    <div class="list_title" @click="sharPrepar(prepare)"><div><div :title="prepare.prepareTitle">{{prepare.prepareTitle}}</div></div><span class="list_bar" v-if="widgetType == 3">查看详情</span></div>
                    <div class="about_info">
                        <div class="list_initiator cont_text_overflow">发起人：<span class="color1" :title="prepare.parperCreatorName">{{prepare.parperCreatorName}}</span></div>
                        <div class="list_time">截止时间：{{prepare.prepareFinishTime | dataSplit}}</div>
                        <div class="list_member" v-if="widgetType != 1">成员：<template v-for="people in prepare.prepareMember">{{people.prepareMemberName}} | </template></div>
                        <!-- <span class="down_btn float_right" v-if="widgetType == 1" @click="down(prepare)"><i class="el-icon-download"></i></span> -->
                    </div>
                    <span class="tag" v-if="prepare.prepareStutas == 0">未结束</span>
                    <span class="tag" v-if="prepare.prepareStutas == 1">已结束</span>
                    
                </div>
                <div class="noData" v-if="tableData.synergeticPreparation.length == 0" style="width:100%"><img src="~css_img/icon_emptypage.png"></div>
            </template>
            <template v-if="tabName == 2">
                <div v-for="(prepare,index) in tableData.personalPreparation" class="prepar_list" :key="index">
                    <div class="img_box" v-if="widgetType != 1"><img :src="imgUrl + prepare.prepareImgUrl" @error="errorImg($event,'image')"></div>
                    <div class="list_title" @click="myPrepar(prepare)"><div><div :title="prepare.prepareTitle">{{prepare.prepareTitle}}</div></div><span class="list_bar" v-if="widgetType == 3">查看详情</span></div>
                    <div class="about_info">
                        <div class="list_initiator cont_text_overflow">创建人：<span class="color1" :title="prepare.parperCreatorName">{{prepare.parperCreatorName}}</span></div>
                        <div class="list_time">截止时间：{{prepare.prepareFinishTime | dataSplit}}</div>
                        <!-- <span class="down_btn float_right" v-if="widgetType == 1" @click="down(prepare)"><i class="el-icon-download"></i></span> -->
                    </div>
                    <span class="tag" v-if="prepare.prepareStutas == 0">未结束</span>
                    <span class="tag" v-if="prepare.prepareStutas == 1">已结束</span>
                </div>
                <div class="noData" v-if="tableData.personalPreparation.length == 0" style="width:100%"><img src="~css_img/icon_emptypage.png"></div>
            </template>
        </div>
        
    </widget>
</template>
<script>
    import widget from './warp'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
            item:{
                type:Object
            }
        },
        data(){
            return {
                widgetType:1,
                router1:'prepare_coll_list',//协同备课
                router2:'prepare_lessons_list',//个人备课
                imgUrl:window.systemParameter.FILE_SYSTEM_URL + "/api/image/thumbnail/",//图片显示地址
                tableData:{
                    synergeticPreparation:[],
                    personalPreparation:[]
                },
                tabName:'2',
                reash:1,
                'userId': window.appframe.$store.state.userInfo.id
            }
        },
        filters:{
            dataSplit:function(val){
                let stemp = val.split(" ")
                return stemp[0]
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    let widgetUrl = stemp[0].apiUrl
                    vm.query(widgetUrl)
                }
            })
            
        },
        methods: {
            query(){
                let vm = this
                http.get('/gateway/prepare/widget',{params:{userId:vm.userId}}).then(function(xhr){
                    let objectA = xhr.data
                    vm.simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                    var newObj = new Object();
                    vm.tableData = widgetFilter.showProps(objectA,'',vm.simpleMap,newObj)
                    // console.log("=============协同备课",vm.tableData)
                })
            },
            myPrepar(item){
                let par = {
                    id: item.prepareId,
                    breadcrumb: [{name: '查看详情', component: 'prepare_lessons_view'}]
                }
                this.$irouter({name: 'prepare_lessons_view', param: par});
            },
            sharPrepar(item){
                let par = {
                    id: item.prepareId,
                    breadcrumb: [{name: '查看详情', component: 'prepare_coll_view'}]
                }
                this.$irouter({name: 'prepare_coll_view', param: par});
            },
            // nodeSplicing(){
            //     let irouter = widgetFilter.nodeSplicing(arguments[0],this.configList,this.simpleMap)
            //     if(irouter)
            //     console.log(irouter)
            //     this.$irouter(irouter)
            // },
            tabNameFn(type){
                this.tabName = type
                this.reash = Math.random()
            }
        }
    }
</script>
<style scoped lang="less">
    .widget_cont{
        height: 280px;
        overflow: hidden;
    }
    .prepar_list{
        position: relative;
        color: #666;
        font-size: 12px;
        .list_title{
            color: #333;
            font-size:14px;
            font-weight:bold;
            cursor: pointer;
            div{
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            div:hover{
                color: #4183fc;
            }
            .list_bar:hover{
                color: #4183fc;
            }
        }
        .list_member{
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            .n {padding:0 2px;}
        }
        .tag{
            background: #E7FAEF;
            color: #52d0b1;
            padding: 1px 8px;
            border:1px solid #52d0b1;
            border-radius: 3px;
            display: inline-block;
            vertical-align: top;
            margin-top: 4px;
        }
    }
    .color1{
        color: #4183fc;
    }
    .widget_level1{
        .widget_cont{
            padding-top: 12px;
        }
        .prepar_list{
            height: 64px;
            border-bottom:1px dashed #E5E7EA;
            position: relative;
            padding:12px 0; 
        }
        .tag{
            position: absolute;top: 10px;left: 0;
        }
        .list_title{
            margin-left: 68px;
            line-height: 22px;
            margin-bottom: 4px;
        }
        .list_initiator{
            margin-right: 18px;
        }
        .list_initiator,
        .list_time,{
            display: inline-block;
        }
        .about_info{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .widget_level2{
        .widget_cont{
            display: flex;
            flex-wrap:wrap;
        }
        .prepar_list{
            width: 50%;
            margin-top: 18px;
            .list_title{
                margin-bottom: 10px;
            }
            .list_initiator,
            .list_time,
            .list_member{
                margin-bottom: 5px;
            }
            .img_box{
                float: left;
                height: 117px;
                width: 117px;
                margin-right:12px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .prepar_list:nth-child(2n+1){
            padding-right: 10px;
        }
        .prepar_list:nth-child(2n+2){
            padding-left: 10px;
        }
    }
    .widget_level3{
        .widget_cont{
            height: 264px;
        }
        .prepar_list{
            float: left;
            width: 175px;
            padding-right: 35px;
            margin-top:20px;
            margin-bottom: 30px;
            .list_title{
                height: 140px;
                width: 140px;
                position: absolute;top:0px;left:0;
                background:rgba(0,0,0,0.5);
                color:#fff;
                padding:30px 15px;
                text-align:center;
                &>div{
                    font-size: 18px;
                    line-height: 40px;
                    height: 40px;
                    div{
                        line-height:20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space:normal;
                    }
                }
                span{
                    font-weight: normal;
                    margin-top: 10px;
                    display: block;
                    font-size: 12px;
                }
            }
            .list_initiator,
            .list_time{
                margin-bottom: 5px;
            }
            .list_member{
                margin-bottom: 10px;
            }
            .img_box{
                height: 140px;
                width: 140px;
                margin-bottom: 12px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .prepar_list:last-child{
            padding-right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/prepar.vue